import React, { useState, useEffect } from "react";
import "../../../components/Styles/FirstPage.css";
import "../../../components/Styles/FormStyle.css";

import swal from "sweetalert";
import RSelect from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/fontawesome-free-regular";
import { faPhone } from "@fortawesome/fontawesome-free-solid";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker, { registerLocale } from "react-datepicker";
import ReactPlayer from "react-player";
import pl from "date-fns/locale/pl"; // the locale you want
registerLocale("pl", pl); // register it with the name you want

const AddLead = (props) => {
  const [loading, setLoading] = useState(true);
  const [creditBank, setCreditBank] = useState(props.creditBank);
  const [creditAmmount, setCreditAmmount] = useState(props.creditAmmount);
  const [creditDate, setCreditDate] = useState(props.creditDate);
  const [userName, setUserName] = useState("");
  const [userPhone, setUserPhone] = useState("");
  const [userMail, setUserMail] = useState("");
  const [userExpectations, setUserExpectations] = useState(
    "Ilość wygranych spraw"
  );
  const [userRegion, setUserRegion] = useState("Dolnośląskie");
  const [agreements, setAgreements] = useState([]);

  const fetchAgreements = () => {
    fetch("https://api.twojeskd.pl/agreements")
      .then((response) => response.json())
      .then((data) => {
        setAgreements(data);
      });
  };

  useEffect(() => {
    fetchAgreements();
  }, []);

  const regionList = [
    "Dolnośląskie",
    "Kujawsko-Pomorskie",
    "Lubelskie",
    "Lubuskie",
    "Łódzkie",
    "Małopolskie",
    "Mazowieckie",
    "Opolskie",
    "Podkarpackie",
    "Podlaskie",
    "Pomorskie",
    "Śląskie",
    "Świętokrzyskie",
    "Warmińsko-Mazurskie",
    "Wielkopolskie",
    "Zachodniopomorskie",
  ];

  const focus = (e) => {
    if (e.target.value === "0") {
      if (e.target.name === "creditAmmount") {
        setCreditAmmount("0");
      }
    }
    e.target.select();
  };

  const checkDigit = (e) => {
    if (!/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  };

  const validateForm = () => {
    if (
      !creditBank ||
      !creditAmmount ||
      !creditDate ||
      !userName ||
      !userPhone ||
      !userMail ||
      !userExpectations ||
      !userRegion
    ) {
      return false;
    } else {
      return true;
    }
  };

  const clearForm = () => {
    setCreditBank("Alior Bank S.A.");
    setCreditAmmount(0);
    setCreditDate("2025-05-05");
    setUserName("");
    setUserPhone("");
    setUserMail("");
    setUserExpectations("Ilość wygranych spraw");
    setUserRegion("Dolnośląskie");
  };

  const submitFirstForm = (e) => {
    if (validateForm()) {
      var body = {
        name: userName,
        phone: userPhone,
        mail: userMail,
        creditAgreement: creditBank,
        creditAmmount: creditAmmount,
        creditDate: creditDate,
        creditCurrency: "PLN",
        leadArea: userRegion,
        leadExpectations: userExpectations,
      };

      fetch("https://api.twojeskd.pl/insert_lead_basic", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {
          swal({
            icon: "success",
            text: `Dodano lead`,
            button: {
              text: "Ok",
            },
          }).then(() => {
            clearForm();
          });
        })
        .catch((error) => {});
    } else {
      swal({
        icon: "error",
        text: `Należy uzupełnić wymagane pola formularza!`,
        button: {
          text: "Ok",
        },
      });
    }
  };

  return (
    <>
      <div className="mainContainerFirst">
        <div className="contentFirst" style={{ width: "100%" }}>
          <div className="formContainerFirst" style={{ width: "100%" }}>
            <div className="rowFirst">
              <div className="oneColFirst">
                <div
                  id="twoCol_columnFirst_title"
                  className="twoCol_columnFirst"
                >
                  <label>
                    Wybierz bank, w którym masz kredyt
                    <span className="requiredStar">*</span>
                  </label>
                </div>
                <div id="oneColFirst_column" className="twoCol_columnFirst">
                  <RSelect
                    className="currencySelect"
                    value={creditBank}
                    onChange={(e) => {
                      setCreditBank(e.value);
                    }}
                    options={agreements.map((agreement) => ({
                      value: agreement.agreement,
                      key: agreement.agreement,
                      label: (
                        <>
                          <img
                            src="https://twojeskd.pl/wp-content/uploads/2023/12/select_bank.png"
                            width="20px"
                            className="imgSelect"
                          />
                          <span className="selectInside">
                            {agreement.agreement}
                          </span>
                        </>
                      ),
                    }))}
                    placeholder={creditBank ? creditBank : "Wybierz z listy..."}
                  />
                </div>

                <div
                  className="rowFirst"
                  style={{
                    marginTop: "3vh",
                    width: "100%",
                    display: "flex",
                    gap: "10px",
                    boxSizing: "border-box",
                  }}
                >
                  <div id="oneColFirst_column" style={{ width: "50%" }}>
                    <label>
                      Kwota kredytu
                      <span className="requiredStar">*</span>
                    </label>
                    <input
                      type="number"
                      id="creditAmmount"
                      name="creditAmmount"
                      placeholder="150000"
                      onFocus={focus}
                      value={creditAmmount}
                      onChange={(e) => {
                        setCreditAmmount(e.target.value);
                      }}
                      onKeyPress={checkDigit}
                    />
                  </div>
                  <div id="oneColFirst_column" style={{ width: "50%" }}>
                    <label style={{ marginBottom: "1vh" }}>
                      Data uruchomienia kredytu
                      <span className="requiredStar">*</span>
                    </label>
                    <div>
                      <input
                        type="date"
                        value={creditDate}
                        onChange={(e) => {
                          setCreditDate(e.target.value);
                        }}
                        dateFormat="yyyy-MM-dd"
                      />
                    </div>
                  </div>
                </div>

                <div
                  className="rowFirst"
                  style={{
                    marginTop: "3vh",
                    width: "100%",
                    display: "flex",
                    gap: "10px",
                    boxSizing: "border-box",
                  }}
                >
                  <div id="oneColFirst_column" style={{ width: "50%" }}>
                    <label>
                      Imię i nazwisko
                      <span className="requiredStar">*</span>
                    </label>
                    <input
                      type="text"
                      id="creditAmmount"
                      name="creditAmmount"
                      value={userName}
                      onChange={(e) => {
                        setUserName(e.target.value);
                      }}
                    />
                  </div>
                  <div id="oneColFirst_column" style={{ width: "50%" }}>
                    <label>
                      numer telefonu
                      <span className="requiredStar">*</span>
                    </label>
                    <input
                      type="text"
                      id="creditAmmount"
                      name="creditAmmount"
                      value={userPhone}
                      onChange={(e) => {
                        setUserPhone(e.target.value);
                      }}
                    />
                  </div>
                </div>

                <div
                  className="rowFirst"
                  style={{
                    marginTop: "3vh",
                    width: "100%",
                    display: "flex",
                    gap: "10px",
                    boxSizing: "border-box",
                  }}
                >
                  <div id="oneColFirst_column" style={{ width: "50%" }}>
                    <label>
                      Adres e-mail
                      <span className="requiredStar">*</span>
                    </label>
                    <input
                      type="text"
                      id="creditAmmount"
                      name="creditAmmount"
                      value={userMail}
                      onChange={(e) => {
                        setUserMail(e.target.value);
                      }}
                    />
                  </div>

                  <div id="oneColFirst_column" style={{ width: "50%" }}>
                    <label>
                      Co ważne dla klienta
                      <span className="requiredStar">*</span>
                    </label>
                    <select
                      style={{
                        borderRadius: "0px",
                        height: "4vh",
                        backgroundColor: "transparent",
                        border: "none",
                        borderBottom: "1px solid black",
                      }}
                      type="text"
                      id="creditAmmount"
                      name="creditAmmount"
                      value={userExpectations}
                      onChange={(e) => {
                        setUserExpectations(e.target.value);
                      }}
                    >
                      <option key={0} value={"Ilość wygranych spraw"}>
                        Ilość wygranych spraw
                      </option>
                      <option key={1} value={"Lokalizacja"}>
                        Lokalizacja
                      </option>
                      <option key={2} value={"Cena"}>
                        Cena
                      </option>
                    </select>
                  </div>
                </div>

                <div
                  className="rowFirst"
                  style={{
                    marginTop: "3vh",
                    width: "100%",
                    display: "flex",
                    gap: "10px",
                    boxSizing: "border-box",
                  }}
                >
                  <div id="oneColFirst_column" style={{ width: "50%" }}>
                    <label>
                      Region
                      <span className="requiredStar">*</span>
                    </label>
                    <select
                      style={{
                        borderRadius: "0px",
                        height: "4vh",
                        backgroundColor: "transparent",
                        border: "none",
                        borderBottom: "1px solid black",
                      }}
                      type="text"
                      id="creditAmmount"
                      name="creditAmmount"
                      value={userRegion}
                      onChange={(e) => {
                        setUserRegion(e.target.value);
                      }}
                    >
                      {regionList.map((el) => (
                        <option key={el} value={el}>
                          {el}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="rowFirst">
                  <button
                    className="submitButtonFirstPage"
                    onClick={submitFirstForm}
                  >
                    Dodaj lead
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddLead;
